<template id="starting-soon-filter">
    <button class="starting-soon-btn" :class="{applied: filterApplied}" @click="onClickFilter">
        Starting Soon
        <button type="button" :class="{applied: filterApplied}" class="close" v-show="filterApplied">&times;</button>
    </button>
</template>

<script>
import QuickFilter from './QuickFilter';

export default {
  template: '#starting-soon-filter',
  extends: QuickFilter,
  computed: {
    filterApplied: function() {
      return this.$store.state.filters.startingSoon;
    }
  },
  methods: {
    updateFilterOnStore: function() {
      var filterApplied = !this.filterApplied;
      this.$store.commit('updateStartingSoonFilter', filterApplied);
    }
  }
}
</script>
